import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import "./notificationCustomOptions.scss";
import Radio from "components/atoms/Radio/Radio";
import { useEffect } from "react";

interface NotificationCustomOptionsProps {
  radioOptions: {
    label: string;
    value: string;
  }[];
  formKey: string;
  defaultKeys: {
    key: string;
    label: string;
    value: string;
  }[];
}

const NotificationCustomOptions = function (props: NotificationCustomOptionsProps) {
  const { radioOptions, formKey, defaultKeys } = props;
  const { watch, setValue } = useFormContext();

  const customNotifications: any = watch(formKey);

  useEffect(() => {
    if (!customNotifications || customNotifications?.length === 0) {
      setValue(formKey, defaultKeys);
    }
  }, [customNotifications]);

  const findIndex = (key: string) => {
    const index = customNotifications?.findIndex((item: any) => item.key === key);
    return index;
  };

  return (
    <div className="mt-3">
      {defaultKeys?.map((item: any, index: any) => (
        <Row
          key={item.key}
          className={`d-flex align-items-center custom-notification ${
            index < defaultKeys.length - 1 && "notification-border"
          }`}
        >
          <Col md={3}>
            <div className="font-weight-bold font-b2">{item.label}</div>
          </Col>
          <Col md={7}>
            <Radio
              noBorder
              name={`${formKey}.${findIndex(item.key)}.value`}
              options={radioOptions}
              customOption
              defaultChecked="true"
              className="border-grey"
              eventContext="Settings - Notifications"
            />
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default NotificationCustomOptions;
